var msg: Translations = {
    "msg.form.invalidemail": "E-mail inválido ou em falta",
    "msg.form.invalidrecipients": "Ocorreu um erro. Contacte a administração relatando o seguinte: \"Destinatários de contacto inválidos ou ausentes.\"",
    "msg.form.invalidtype": "Ocorreu um erro. Contacte a administração relatando o seguinte: \"Tipo de contacto inválido ou ausente.\"",
    DELETEALLPRODUCTSERROR: 'Error removing products from cart',
    ERR_CARRIERMISSING: 'Deve selecionar um tipo de envio',
    ERR_CARRIER_COST_MISSING: 'Nenhuma tarifa aplicável por país, transportadora e peso \'encomenda. ',
    ERR_CLIENTMANDATORYFIELDS: 'Os campos indicados são obrigatórios',
    ERR_DATE_FROM: "Date must be after :from",
    ERR_DATE_FROM_TO: "Date must be between :from and :to",
    ERR_DATE_TO: "Date must be before :to",
    ERR_FILE_TOO_LARGE: "O ficheiro é demasiado grande (tamanho máximo: :size)",
    ERR_FILLEMAILFIELD: 'Preencher o campo correio eletrónico',
    ERR_INVALIDMAIL: 'Correio eletrónico inválido',
    ERR_LIGHTBOX_LOADING: 'Image detail is loading, try again in a few seconds',
    ERR_LOGININVALID: 'Correio eletrónico e/ou palavra-chave inválidos',
    ERR_LOGINREQUIRED: 'Deve efetuar o\'acesso',
    ERR_MISSINGFIELDS: 'Completar corretamente todos os campos obrigatórios',
    ERR_NOSIZESELECTED: 'Antes deve selecionar um tamanho',
    ERR_PEC_OR_SDI: 'Fill in at least one of PEC and SDI',
    ERR_PHONE_FORMAT_GENERIC: "Número de telefone inválido",
    ERR_PHONE_FORMAT_INVALID_COUNTRY: "País inválido",
    ERR_PHONE_FORMAT_NOT_A_NUMBER: "Só pode conter caracteres numéricos",
    ERR_PHONE_FORMAT_TOO_LONG: "Número de telefone demasiado longo",
    ERR_PHONE_FORMAT_TOO_SHORT: "Número de telefone demasiado curto",
    ERR_PRIVACY: 'Para avançar você deve aceitar as condições',
    ERR_USEREXISTS: 'O utilizador já existe.',
    ERR_VAT: 'Incorrect VAT format',
    ERR_VAT_PREFIX: 'VAT must begin with country code (e.g. IT, FR)',
    ERR_ZIP_FORMAT: "",
    LABEL_ALREADYREGISTEREDUSERES: 'Utilizadores já registados',
    LABEL_ARTICLES: 'artigos',
    LABEL_CANCEL: 'Cancel',
    LABEL_CONFIRM: 'Confirm',
    LABEL_INVITES_ALREADY_SENT: 'Utilizadores já convidados',
    LABEL_NOTAPPLICABLE: 'Não aplicáveis',
    LABEL_NOTSENTINVITES: 'Convites não enviados',
    LABEL_SELECTALL: 'Selecionar todos',
    LABEL_SENTINVITES: 'Convites enviados',
    LABEL_SUBMIT: 'Enviar',
    LABEL_WARNING: 'Atenção',
    MSG_ADDEDTOCART: 'Produtos adicionados ao carrinho',
    MSG_ADDED_TO_WISHLIST: 'Este produto foi adicionado à lista de desejos',
    MSG_APPLIEDVATCHANGED: 'IVA aplicado sobre a sua encomenda foi alterado. ',
    MSG_COUPON_ERROR: 'O código do cupão inserido é inválido ou já foi previamente inserido.',
    MSG_COUPON_VALID: 'O código do cupão inserido foi validado com sucesso.',
    MSG_DEFERRED_DISPATCH_COMPUTATION: 'Será habilitada a única reserva da\'encomenda e os custos associados ao envio serão comunicados via correio eletrónico',
    MSG_DELETEALLPRODUCTS: 'Are you sure you want to remove all products from the cart?',
    MSG_EXTRAUELIMIT: 'A\'quantidade mínima da sua encomenda não pode ser inferior a 2 000,00 €',
    MSG_GENERIC_ERROR: 'Lamentamos, mas ocorreu um erro. ',
    MSG_INSUFFICIENT_STOCK: 'De momento a disponibilidade do produto é insuficiente.',
    MSG_INVALID_CAPTCHA: 'Invalid captcha code',
    MSG_MAILSENT: 'E-Correios eletrónicos enviados',
    MSG_MESSAGE_PRODUCTSHARE: 'Mensagem',
    MSG_CONTACT_SENT: 'Mensagem enviada!',
    MSG_MESSAGE_SENT: 'Mensagem enviada!',
    MSG_MIXED_CART: 'Os produtos no carrinho não podem ser comprados juntamente com o produto escolhido, por se encontrarem em armazéns diferentes.',
    MSG_MIXED_INTANGIBLE: 'Os produtos no carrinho não podem ser comprados juntamente com o produto selecionado.',
    MSG_MUST_ACCEPT_TERMS: 'You must accept the terms of use',
    MSG_NEWSLETTER_COMPLETED: 'Successful registration',
    MSG_PASSWORD_NOT_COMPLEX: 'Password must include at least 1 uppercase character, 1 lowercase character and 1 number and be at least 8 characters long',
    MSG_PASSWORD_NOT_EQUAL: 'A nova senha e a senha de confirmação não correspondem',
    MSG_PASSWORD_OK: 'Senha alterada com sucesso',
    MSG_PASSWORD_RESET: 'Password was succesfully reset',
    MSG_PAYMENT_PENDING: 'Validação de pagamento pendente',
    MSG_PRIVACY_POLICY: 'You must accept the privacy policy',
    MSG_PROFILECONSENT_SAVED: 'Suas preferências de contato foram atualizadas',
    MSG_RECOVEREMAILSENT: 'Verifique o seu correio eletrónico e clique no link para confirmar a alteração.',
    MSG_RECOVEREMAILSENT_ERROR: 'Atenção: Não está registado com este endereço de correio eletrónico, ou já está a definir uma nova palavra-chave.',
    MSG_REMOVED_FROM_WISHLIST: 'Product removed from your wishlist',
    MSG_RETURN_REQUEST: 'Return request created successfully',
    MSG_RETURN_REQUEST_ERROR: 'Return request could not be created, contact the admin',
    MSG_RETURN_REQUEST_SUCCESS: 'Pedido de devolução criado com sucesso',
    MSG_RULE_REJECT: 'Product cannot be added to cart because of rule :rule',
    MSG_SAVE_SUCCESS: 'Guardado com sucesso',
    MSG_SELECT_PROVINCE: "Select a province",
    MSG_SENDER_PRODUCTSHARE: 'O seu nome',
    MSG_SUBJECT_PRODUCTSHARE: ' partilhou algo consigo',
    MSG_SUBSCRIBED: 'Inscrito com sucesso',
    MSG_SUBSCRIPTION_FAILURE: 'Make sure you do not have any other active subscription',
    MSG_SUBSCRIPTION_NO_RENEWABLE: 'Muitos dias se passaram portanto a assinatura não é mais renovável',
    MSG_TOKEN_SENT: 'We have sent a verification code to your e-mail address. Check that you have received our message and input the code',
    MSG_USER_ALREADY_REGISTERED: 'User is already registered',
    MSG_USER_NOT_FOUND: 'User not found',
    MSG_WAIT: 'Aguardar...',
    MSG_WRONG_PASSWORD: 'Wrong password'
}